import { Icon } from '@app/src/common/Icon';
import { COLORS } from '@app/src/ui';
import React, { useEffect, useState } from 'react';
import {
  Wrapper,
  ButtonBefore,
  ButtonNext,
  Page,
  IconBefore,
  IconNext
} from './styled';

interface Props {
  totalPages: number;
  pageGroup: number;
  handleClickPageActive?: Function;
  initialPage: number;
  dataList: Array<any>;
}

export const Paginator: React.FC<Props> = ({
  totalPages,
  pageGroup,
  handleClickPageActive,
  initialPage,
  dataList
}) => {
  const [pages, setPages] = useState(null);
  const [pageActive, setPageActive] = useState(null);
  const [groupBy, setGroupBy] = useState(null);

  useEffect(() => {
    window.addEventListener('resize', handleResize);
    handleResize();
    return () => {
      window.removeEventListener('resize', handleResize);
    }
  }, []);

  useEffect(() => {
    if (initialPage) {
      setPageActive(initialPage);
    }
  }, [initialPage]);

  useEffect(() => {
    if (dataList && dataList.length > 0) {
      buildPaginator(groupBy, pageActive);
    }
  }, [groupBy, dataList, pageActive]);

  const buildPaginator = (pageGroup, pageActive) => {
    let arrBefore = [];
    let arrNext = []
    let half = Math.ceil(pageGroup/2);
    let minus = half;
    for (let i = 1; i <= half; i++) {
      minus--;
      if (pageActive - minus > 0) {
        arrBefore.push(pageActive - minus);
      } 
    }
    
    for (let i = 1; i <= pageGroup; i++) {
      let pagesLength = arrBefore.length + arrNext.length;
      if ( pageActive + i <= totalPages && pagesLength < pageGroup) {
        arrNext.push(pageActive + i);
      }
    }
    setPages([ ...arrBefore, ...arrNext]);
  };

  const handleResize = () => {
    if ( window.innerWidth > 768) {
      setGroupBy(pageGroup);
    } else {
      setGroupBy(3);
    }
  };

  const handleClickPaginator = (e) => {
    e.stopPropagation();
    const element = e.target;
    const dataAction = element.dataset.paginator;
    let newActive = Number(dataAction) || 1;

    if (dataAction) {
      if (dataAction === 'prev') {
        if (pageActive > 1) {
          const old = [...pages];
          const firstOld = old[0];
          newActive = pageActive - 1;

          if (newActive === firstOld && newActive > 1) {
            const newPageGroup = pages.map((page) => page - 1);
            setPages(newPageGroup);
          }

          setPageActive(newActive);
          handleClickPageActive && handleClickPageActive(newActive);
        }
      } else if (dataAction === 'next') {
        if (pageActive < totalPages) {
          newActive = pageActive + 1;
          const old = [...pages];
          const lastOld = old[old.length - 1];
          if (newActive > lastOld) {
            const newPageGroup = pages.map((page) => page + 1);
            setPages(newPageGroup);
          }
          setPageActive(newActive);
          handleClickPageActive && handleClickPageActive(newActive);
        }
      } else {
        if (newActive >= 1 && newActive <= totalPages) {
          setPageActive(newActive);
          handleClickPageActive && handleClickPageActive(newActive);
        }
      }
    }
  };

  return (
    <Wrapper onClick={handleClickPaginator}>
      <ButtonBefore
        data-paginator="prev"
        disabled={pageActive === 1}>
        <IconBefore data-paginator="prev">
          <Icon data-name="icon-expand-more" width="12" height="12" fill={COLORS.GRAY_TEXT} />
        </IconBefore>
        Anterior
      </ButtonBefore>
      {
        pages && pages.map((item, index) => (
          <Page
            data-paginator={item}
            key={index}
            active={item == pageActive}>{item}</Page>
        ))
      }
      <ButtonNext data-paginator="next" disabled={pageActive === totalPages}>
        Siguiente
      <IconNext data-paginator="next" >
          <Icon data-name="icon-expand-more" width="12" height="12" fill={COLORS.GRAY_TEXT} />
        </IconNext>
      </ButtonNext>
    </Wrapper>
  )
};